import { useEffect, useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '../../shared/api.js';

// أقل عدد حروف يبدأ عنده البحث — حرف واحد يُرجع نصف قاعدة البيانات بلا فائدة.
export const MIN_CHARS = 2;
// تأخير الكتابة: لا طلب لكل ضغطة زر.
export const DEBOUNCE_MS = 250;

/** يؤخّر قيمة حتى يتوقف المستخدم عن الكتابة. */
export function useDebounced(value, ms = DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}

/**
 * البحث العام — يُرجع { query, groups: [...], total }.
 * الخادم هو من يقرّر أي مجموعات يراها هذا المستخدم، فلا تصفية صلاحيات هنا.
 */
export function useGlobalSearch(term) {
  const q = String(term || '').trim();
  return useQuery({
    queryKey: ['global-search', q],
    queryFn: async () => {
      const { data } = await api.get('/search', { params: { q } });
      return data && Array.isArray(data.groups) ? data : { query: q, groups: [], total: 0 };
    },
    enabled: q.length >= MIN_CHARS,
    staleTime: 15000,
    placeholderData: keepPreviousData,
    retry: false
  });
}

/** تفاصيل سجل واحد من نتائج البحث. */
export function useSearchRecord(type, id) {
  return useQuery({
    queryKey: ['search-record', type, id],
    queryFn: async () => {
      const { data } = await api.get(`/search/record/${type}/${id}`);
      return data;
    },
    enabled: !!type && !!id,
    retry: false
  });
}
